// extracted by mini-css-extract-plugin
module.exports = {"container":"Delete_container_3UrHD","filelabel":"Delete_filelabel_27hr7"};